import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ControllerSettings from '../Components/ControllerSettings';
import LineItemsPreview from '../Components/LineItemsPreview';
import InfoIcon from '../../../assets/icons/alert.svg';

const ControllerContainer = styled.div`
  min-height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 24px 16px;
`;

const PreviewTableContainer = styled.div`
  margin-top: 20px;
  border-radius: 8px;
  padding: 20px 10px 20px 10px;
  background: var(--light-primary-background-color, #fff);
  width: 971px;
`;

const PreviewAlertContainer = styled.div`
  margin-top: 20px;
  border-radius: 8px;
  padding: 5px;
  background: var(--light-primary-background-color, #fff);
  width: 971px;
  background-color: white;

  .alert {
    height: 55px;
    width: 100%;
    padding: 10px;
    display: flex;
    gap: 10px;
    align-items: center;
    border-radius: 4px;
    background: var(--light-allgrey-background-color, #f5f6f8);
    color: var(--light-primary-text-color, #323338);
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

const LineItemsControllerModal = () => {
  const { t } = useTranslation();
  return (
    <>
      <ControllerContainer>
        <ControllerSettings
          t={t}
          render={(lineItemState, tableHeaderRef, subItems, lineItemId) => (
            <>
              {subItems?.columns?.length ? (
                <PreviewTableContainer>
                  <LineItemsPreview
                    lineItemData={lineItemState}
                    width={951} //width after removing padding from outer container
                    tableHeaderRef={tableHeaderRef}
                    isResizable
                    t={t}
                    lineItemId={lineItemId}
                    mondayColumnsData={subItems?.columns}
                  />
                </PreviewTableContainer>
              ) : (
                <PreviewAlertContainer>
                  <div className="alert">
                    <img src={InfoIcon} alt="" />
                    {t(
                      'Sub-items are pulled from your board sub-items. Add sub-items to your board to reflect them here.',
                    )}
                  </div>
                </PreviewAlertContainer>
              )}
            </>
          )}
        />
      </ControllerContainer>
    </>
  );
};

export default LineItemsControllerModal;
